import React from 'react'

// Partials
import Btn from 'views/shared/partials/btn'

const NotFound = (props) => {
	return (
		<section className="page admin-notfound portlet error">
			<div className="portlet-header">
				<strong className="portlet-title">Hata</strong>

				<div className="header-controls">
					<Btn white small wide icon="angle-left-thin" tag="link" href="dashboard">Anasayfaya Dön</Btn>
				</div>
			</div>
			<div className="portlet-section bottom">
				<p>İşleminizi gerçekleştirirken bir hata ile karşılaşıldı. Lütfen tekrar deneyin.</p>
			</div>
		</section>
	)
}

export default NotFound